module.exports = __webpack_public_path__ + "static/media/8OLA11.a215aace.jpg";